"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The Module model module.
 * @module model/Module
 * @version 0.2.0
 */
var Module = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Module</code>.
   * @alias module:model/Module
   */
  function Module() {
    _classCallCheck(this, Module);

    Module.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(Module, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>Module</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Module} obj Optional instance to populate.
     * @return {module:model/Module} The populated <code>Module</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Module();

        if (data.hasOwnProperty('moduleID')) {
          obj['moduleID'] = _ApiClient["default"].convertToType(data['moduleID'], 'String');
        }

        if (data.hasOwnProperty('moduleName')) {
          obj['moduleName'] = _ApiClient["default"].convertToType(data['moduleName'], 'String');
        }
      }

      return obj;
    }
  }]);

  return Module;
}();
/**
 * @member {String} moduleID
 */


Module.prototype['moduleID'] = undefined;
/**
 * @member {String} moduleName
 */

Module.prototype['moduleName'] = undefined;
var _default = Module;
exports["default"] = _default;